import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetMotivosDemissaoUseCase } from "../../../presentation/useCases/read/get_motivos_demissao_use_case";
import { MotivoDemissao } from "../../models/motivo_demissao";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * IGetMotivosDemissaoUseCase
 */

export class GetMotivosDemissaoUseCase extends BasePaginatedUseCase<MotivoDemissao> implements IGetMotivosDemissaoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
    super();
  }

  async getMotivosDemissao(
    tipoPesquisa: number,
    motivoDemissao: string,
    status: number,
    page: number,
    pageSize: number,
  ): Promise<void> {
    const response = await this.repository.getMotivosDemissao(
      tipoPesquisa,
      motivoDemissao,
      status,
      page,
      pageSize,
    );

    this._items = response.items;
    this._pageSize = response.pageSize;
    this._currentPage = response.currentPage;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}